module.exports = __webpack_public_path__ + "img/xingbida@2x.1f60f924.png";